module.exports = __webpack_public_path__ + "images/emoji/calling.559bfa4625b0333e6571.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/calling.png
// module id = 8JdY
// module chunks = 13